import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneSU_NT_MRI_ResearchExperience = createAsyncThunk(
  "SU_NT_MRI_ResearchExperienceServices/GetOneSU_NT_MRI_ResearchExperience",
  async (researchExperienceId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ResearchExperienceServices/GetOneSU_NT_MRI_ResearchExperience",
        {
            researchExperienceId: researchExperienceId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteSU_NT_MRI_ResearchExperience = createAsyncThunk(
  "SU_NT_MRI_ResearchExperienceServices/DeleteSU_NT_MRI_ResearchExperience",
  async (researchExperienceId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ResearchExperienceServices/DeleteSU_NT_MRI_ResearchExperience",
        {
            researchExperienceId: researchExperienceId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateSU_NT_MRI_ResearchExperience = createAsyncThunk(
  "SU_NT_MRI_ResearchExperienceServices/UpdateSU_NT_MRI_ResearchExperience",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ResearchExperienceServices/UpdateSU_NT_MRI_ResearchExperience",
        {
            researchExperienceId: model.researchExperienceId,
            typeExperienceId: model.typeExperienceId,
            address: model.address,
            yearId: model.yearId,
            party: model.party,
            summary: model.summary,
            applicationInformationId: model.applicationInformationId
          }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddSU_NT_MRI_ResearchExperience = createAsyncThunk(
  "SU_NT_MRI_ResearchExperienceServices/AddSU_NT_MRI_ResearchExperience",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ResearchExperienceServices/AddSU_NT_MRI_ResearchExperience",
        {
            typeExperienceId: model.typeExperienceId,
            address: model.address,
            yearId: model.yearId,
            party: model.party,
            summary: model.summary,
            applicationInformationId: model.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ResearchExperience = createSlice({
  name: "ResearchExperience",
  initialState: {
    researchExperience: {},
    loadingresearchExperience: false,
    errorresearchExperience: null,

    AddresearchExperience: {},
    loadingAddresearchExperience: false,
    errorAddresearchExperience: null,

    UpdateresearchExperience: {},
    loadingUpdateresearchExperience: false,
    errorUpdateresearchExperience: null,

    DeleteresearchExperience: {},
    loadingDeleteresearchExperience: false,
    errorDeleteresearchExperience: null,

    ListresearchExperience: {},
    loadingListresearchExperience: false,
    errorListresearchExperience: null,
  },
  reducers: {
   
  },

  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneSU_NT_MRI_ResearchExperience.pending,
        (state, action) => {
          state.loadingresearchExperience = true;
          state.researchExperience = action.payload;
          state.errorresearchExperience = null;
        }
      )
      .addCase(
        GetOneSU_NT_MRI_ResearchExperience.fulfilled,
        (state, action) => {
          state.loadingresearchExperience = false;
          state.researchExperience = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneSU_NT_MRI_ResearchExperience.rejected,
        (state, action) => {
          state.loadingresearchExperience = false;
          state.errorresearchExperience = action.payload;
        }
      )

      .addCase(
        DeleteSU_NT_MRI_ResearchExperience.pending,
        (state, action) => {
          state.loadingDeleteresearchExperience = true;
          state.DeleteresearchExperience = action.payload;
          state.errorDeleteresearchExperience = null;
        }
      )
      .addCase(
        DeleteSU_NT_MRI_ResearchExperience.fulfilled,
        (state, action) => {
          state.loadingDeleteresearchExperience = false;
          state.DeleteresearchExperience = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        DeleteSU_NT_MRI_ResearchExperience.rejected,
        (state, action) => {
          state.loadingDeleteresearchExperience = false;
          state.errorDeleteresearchExperience = action.payload;
        }
      )

      .addCase(UpdateSU_NT_MRI_ResearchExperience.pending, (state, action) => {
        state.loadingUpdateresearchExperience = true;
        state.UpdateresearchExperience = action.payload;
        state.errorUpdateresearchExperience = null;
      })
      .addCase(
        UpdateSU_NT_MRI_ResearchExperience.fulfilled,
        (state, action) => {
          state.loadingUpdateresearchExperience = false;
          state.UpdateresearchExperience = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(UpdateSU_NT_MRI_ResearchExperience.rejected, (state, action) => {
        state.loadingUpdateresearchExperience = false;
        state.errorUpdateresearchExperience = action.payload;
      })

      .addCase(AddSU_NT_MRI_ResearchExperience.pending, (state, action) => {
        state.loadingAddresearchExperience = true;
        state.AddresearchExperience = action.payload;
        state.errorAddresearchExperience = null;
      })
      .addCase(AddSU_NT_MRI_ResearchExperience.fulfilled, (state, action) => {
        state.loadingAddresearchExperience = false;
        state.AddresearchExperience = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddSU_NT_MRI_ResearchExperience.rejected, (state, action) => {
        state.loadingAddresearchExperience = false;
        state.errorAddresearchExperience = action.payload;
      });
  },
});

export default ResearchExperience.reducer;
